// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"45e8d3f2","538":"4527a4eb","787":"794782f4"}[chunkId] + ".chunk.js";
};